import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'relativeDateLabel',
  standalone: true,
})
export class RelativeDateLabelPipe implements PipeTransform {
  transform(value: Date | string | null | undefined): string {
    if (!value) {
      return '--';
    }

    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) {
      return '--';
    }

    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const minuteMs = 60 * 1000;
    const hourMs = 60 * minuteMs;

    // Before day-based labels: minutes/hours.
    if (diffMs >= 0 && diffMs < minuteMs) {
      return 'Just now';
    }

    if (diffMs >= minuteMs && diffMs < hourMs) {
      const minutes = Math.floor(diffMs / minuteMs);
      return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
    }

    if (diffMs >= hourMs && diffMs < 24 * hourMs) {
      const hours = Math.floor(diffMs / hourMs);
      return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
    }

    const targetDayStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const msPerDay = 24 * 60 * 60 * 1000;
    const dayDiff = Math.floor((todayStart.getTime() - targetDayStart.getTime()) / msPerDay);

    if (dayDiff <= 0) {
      return 'Today';
    }

    if (dayDiff === 1) {
      return 'Yesterday';
    }

    if (dayDiff <= 29) {
      return `${dayDiff} days ago`;
    }

    if (dayDiff < 365) {
      const months = Math.floor(dayDiff / 30);
      return months <= 1 ? '1 month ago' : `${months} months ago`;
    }

    const years = Math.floor(dayDiff / 365);
    if (years <= 1) {
      return '1 year ago';
    }

    return `${years} years ago`;
  }
}
